/**
 * For react router route hint. DRY.
 */
export enum AppRoutePathEnum {
  SignIn = "/sign-in",
  Welcome = "/welcome",
  Game = "/game",
}
